import { useQuery } from "@tanstack/react-query"
import { getBackofficeBlockedConversationsQuery } from "modules/backoffice/lib/whatsappRoutes/getBackofficeBlockedConversationsQuery"

export function useGetBackofficeBlockedConversationsQuery(
  ...args: Parameters<typeof getBackofficeBlockedConversationsQuery>
) {
  return useQuery(getBackofficeBlockedConversationsQuery(...args))
}
